import { createContext } from 'react';

export type ITextLayerContext = {
    defIDSuffix: string; // 用于生成唯一的 def id，防止 id 重复导致的渲染异常
};

export const TextLayerContext = createContext<ITextLayerContext | null>(null);
